import { NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AuthenticationModes } from 'common/config/models/authentication-modes';
import { BcConfigService } from 'common/config/provider';
import { initializeModule } from './actions/feature-toggles.actions';
import { featureKey } from './reducers/feature-key';
import { genesysCloudFeatureTogglesReducer } from './reducers/feature-toggles.reducer';
import { GenesysCloudFeatureTogglesEffects } from './effects/feature-toggles.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudFeatureTogglesReducer),
    EffectsModule.forFeature([
      GenesysCloudFeatureTogglesEffects
    ])
  ]
})
export class GenesysCloudFeatureTogglesModule {
  constructor(bcConfigService: BcConfigService, store: Store) {
    if (bcConfigService.authenticationMode === AuthenticationModes.GENESYS) {
      store.dispatch(initializeModule());
    }
  }
}

